import SETTINGS from "settings";

export default function( space, MathClass, test_login )
{
    const socket = io(
        'https://wbgdev.ngmcasino.com',
        {
            path: '/nard_server/socket/socket.io',
            query: 'load_test_login='+test_login
        }
    )
    socket.on('connect', () => {
        console.log("========== connected");
        space.s('server_initialized').next(true)
    });
    const $error = space.s( 'error' )
    function handle_error( name ) {
        socket.on( name, () => {
            console.log( '===========', name )
            $error.next( { type : 'fail', message : name } )
        } )
    }
    handle_error( 'disconnect' )
    handle_error( 'connect_failed' )
    handle_error( 'connect_error' )
    handle_error( 'connect_timeout' )
    handle_error( 'reconnect_error' )
    handle_error( 'reconnect_failed' )
    
    const mathNet = new MathClass( socket )
    mathNet.setVerbose(true);
    
    mathNet.cb_account_changed = p => space.s( 'balance_poll' ).next( p )
    mathNet.cb_model_changed = m => space.s( 'net' ).next( m )
    mathNet.cb_model_outdated = e => space.s( 'error' ).next( { type : 'fail', message : e } )
    mathNet.cb_unauthorised = () => {goLobby()};
    mathNet.cb_account_selection_changed = data => {
        space.s( 'account_selection_changed' ).next( data );
        mathNet.doSetGameAccountToPlayerActiveAccount();
        // сброс текущей ставки произойдет в __validateModel
    };
    
    const $result = space.s( 'server_result' )
    space.s( 'server_action' ).on( ({ name, param, bet }) => {
        //making args:
        const args = []
        //TODO: maybe move bet into model?
        if ( bet ) {
            mathNet.setBetValue( bet )
            args.push( bet )
        }
        //first arg is parameters object if needed:
        if ( param !== undefined && param !== null ) args.push( param )
        //second arg is callback which we redirect to appropriate streams:
        args.push( ( err, result ) => {
            if ( err || ! result ) $error.next( {
                type : 'fail',
                message : name + ': ' + JSON.stringify( err ) + ', result: ' + JSON.stringify( result ),
            } )
            
            if ( result ) $result.next( result )
        } )
        
        //TODO: maybe call .setBetValue() here too?
        
        mathNet[ name ].apply( mathNet, args )
    } )

    space.s( 'beforeGoLobby' )
        .on(() => {
            console.log('goLobby - removeAllListeners from socket for not showing disconnect anim');
            socket.off('disconnect');
        });

    space.s( 'beforeGoLobby' ).to(space.s('goToLobby'));

    space.s( 'resetGame' )
        .on(() => {
            console.log('resetGame');
            socket.close();
            socket.open();
        });
}

export function goLobby()
{
    window.space.s('beforeGoLobby').next();

    let lobbyURL = null;
    if (SETTINGS.url_params['lobby_url'] !== undefined) lobbyURL = decodeURIComponent(SETTINGS.url_params['lobby_url']);
    if (SETTINGS.url_params['back_url'] !== undefined)  lobbyURL = decodeURIComponent(SETTINGS.url_params['back_url']);

    if (lobbyURL) {
        console.log('redirecting to', lobbyURL, '...');
        window.location.replace(lobbyURL);
    }
    else {
        console.log('sending', 'game_close', 'message to iframe host ...');
        window.top.postMessage("game_close", "*");
    }
}


// WEBPACK FOOTER //
// ./src/library/minigame_client/minigame_client.es6